// extracted by mini-css-extract-plugin
export var active = "_6w-a";
export var activeIndicator = "_6w-9";
export var disabled = "_6w-b";
export var fullWidth = "_6w-2";
export var lg = "_6w-7";
export var md = "_6w-6";
export var redoButtonTabGroup = "_6w-0";
export var sm = "_6w-5";
export var tabButton = "_6w-4";
export var tabButtonsContainer = "_6w-1";
export var themeDestructive = "_6w-d";
export var themeNormal = "_6w-c";
export var themeSuccess = "_6w-e";
export var xl = "_6w-8";
export var xs = "_6w-3";